import React, { useState } from "react";

import { formatINR } from "utils/format";

/**
 * Sticky total and actions for the membership / sponsorship / daily pass flows.
 *
 * On a phone the stacked version of this stood roughly 200px tall — label, total, note and two
 * full width buttons — which ate a third of the viewport permanently and left about two product
 * tiles visible between it and the header. It now collapses to a single ~60px row carrying the two
 * things a shopper actually needs at all times: what it costs, and how to go on. The note and the
 * secondary action fold away behind a toggle, one tap from view.
 *
 * The desktop layout is untouched; there is room for the full thing there.
 */
function SummaryBar({ label, total, note, children }) {
  const [open, setOpen] = useState(false);
  const hasDetail = note != null && note !== "";

  return (
    <div className={"hm-bar" + (open ? " is-open" : "")}>
      <div className="hm-bar-main">
        <span className="hm-bar-label">{label}</span>
        <div className="hm-bar-total">&#x20B9;{formatINR(total)}</div>
        {hasDetail && (
          <span className="hm-bar-note" id="summaryBarNote">
            {note}
          </span>
        )}
      </div>
      <button
        className="hm-bar-toggle"
        type="button"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        aria-controls="summaryBarNote"
        aria-label={open ? "Hide order details" : "Show order details"}
      >
        <i
          className={
            "now-ui-icons " +
            (open ? "arrows-1_minimal-down" : "arrows-1_minimal-up")
          }
          aria-hidden="true"
        />
      </button>
      <div className="hm-bar-actions">{children}</div>
    </div>
  );
}

export default SummaryBar;
